<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2 v-if="color">
        <v-btn small :to="`/colours/${color.fabric._id}`">Back to {{ color.fabric.name }}</v-btn>
        <v-card>
          <v-card-title>
            <h4>{{ color.fabric.name }} - {{ color.name }}</h4>
            <v-spacer></v-spacer>
          </v-card-title>
          <hr>
          <v-card-text>
            <h2 class="headline">Tags</h2>
            <v-data-iterator :items="color.tags" content-tag="v-layout" row wrap>
              <v-flex slot="item" slot-scope="props" xs12>
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>{{ props.item.name }}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <v-btn small color="primary" @click="deleteTag(color._id, props.index)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-data-iterator>

            <v-select v-model="newTag" :items="availableTags" item-text="label" item-value="_id" label="Add Tag"></v-select>
            <v-btn color="primary" @click="addTag(color._id, newTag)">Add</v-btn>

            <v-text-field v-model="color.position" placeholder="Colour Position (1 is highest)"></v-text-field>
            <v-btn color="primary" @click="updateColor()">Update</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md8 offset-md2 v-if="color">
        <v-card>
          <v-card-title>
            <h4>Image</h4>
            <v-spacer></v-spacer>
          </v-card-title>
          <hr>
          <v-card-text>
            <form enctype="multipart/form-data" novalidate>
              <v-container grid-list-xl fluid>
                <p>Upload a 500x500 fabric image here, a 110x110 thumbnail will be generated.</p>
                <input type="file" name="image" @change="uploadFile($event.target.name, $event.target.files, 'large')" accept="image/*">
                <v-layout row wrap>
                  <v-flex>
                    <p>Large Image (500x500):</p>
                    <img v-bind:src="largeImageURL" width="500" style="float: left; margin-right: 10px; max-width: 100%">
                    <v-text-field v-model="color.largeImage" label="Filename"></v-text-field>
                  </v-flex>
                  <v-flex>
                    <p>Small Image (110x110):</p>
                    <img v-bind:src="smallImageURL" width="110" style="float: left; margin-right: 10px; max-width: 100%">
                    <v-text-field v-model="color.smallImage" label="Filename"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import ColorService from '@/services/ColorService'
import TagService from '@/services/TagService'
export default {
  data () {
    return {
      color: null,
      availableTags: null,
      newTag: null,
      snackbar: false,
      popupText: null
    }
  },
  mounted () {
    this.getColor(this.$route.params.colorID)
    this.getTags()
  },
  computed: {
    largeImageURL () {
      if (this.color.largeImage) {
        return `https://api.diyblinds.com.au/fabricImages/${this.color.largeImage}`
      } else {
        return null
      }
    },
    smallImageURL () {
      if (this.color.smallImage) {
        return `https://api.diyblinds.com.au/fabricImages/${this.color.smallImage}`
      } else {
        return null
      }
    }
  },
  methods: {
    async getColor (colorID) {
      const response = await ColorService.getColor(colorID)
      this.color = response.data.color
    },

    async updateColor () {
      const response = await ColorService.updateColor(this.color)
      if (response.data.success) {
        this.popupText = 'Colour sucessfuly updated'
        this.snackbar = true
      }
    },

    async getTags () {
      const response = await TagService.getTags()
      this.availableTags = response.data.tags
    },

    async addTag (colorID, newTag) {
      await ColorService.addTag({
        colorID: colorID,
        tagID: newTag
      })

      this.getColor(colorID)
    },

    async deleteTag (colorID, tagIndex) {
      await ColorService.deleteTag({
        colorID: colorID,
        tagIndex: tagIndex
      })

      this.getColor(colorID)
    },

    async uploadFile (fieldName, fileList, size) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

      const response = await ColorService.uploadImage(this.color._id, size, formData)
      if (response.data.success) {
        this.color.largeImage = response.data.color.largeImage
        this.color.smallImage = response.data.color.smallImage

        this.popupText = 'Image updated successfully.'
        this.snackbar = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/colours/EditColor.vue